<template>
 <section class="relative px-4 py-8 bg-[#E2ECF4] md:py-16 xl:px-0">
   <div class="max-w-3xl mx-auto">
    <h3 class="text-black md:mb-8 mb-4 text-3xl md:text-4xl font-ww-bold xl:!leading-none xl:text-42 text-center" v-html="mainHeading">
    </h3>
    <div class="text-xl text-center font-ww-medium md:text-2xl xl:text-3xl" v-html="subHeading">
    </div>
   </div>
   <div class="max-w-4xl mx-auto mt-10 lg:mt-16 xl:px-8">
    <div class="text-2xl text-center xl:text-4xl md:text-3xl font-ww-medium" v-html="contentHeading">
    </div>
    <div class="md:mt-4 mt-2 text-base xl:text-lg font-ww-regular !leading-6 text-left" v-html="contentText">
    </div>
   </div>
   <div class="mx-auto mt-4 md:mt-10 max-w-7xl">
        <nuxt-img :src="diagramImageSrc" sizes="xs:291px sm:593px md:720px lg:976px xl:1114px" format="webp" loading="lazy" width="1114" height="586" class="hidden mx-auto md:block" :alt="diagramImageAlt" />

        <nuxt-img :src="diagramImageMobileSrc" sizes="xs:291px sm:593px md:720px lg:976px xl:1114px" format="webp" loading="lazy" width="852" height="1340" class="mx-auto md:hidden" :alt="diagramImageMobileAlt" />
    </div>
    <nuxt-img :src="decorImageSrc" sizes="xs:145px sm:370px md:370px lg:370px xl:370px" format="webp" loading="lazy" width="370" height="370" class="absolute right-0 z-20 w-32 mx-auto md:w-40 lg:w-64 xl:-bottom-32 2xl:-bottom-40 md:-bottom-16 lg:-bottom-32 -bottom-20 xl:w-auto" :alt="decorImageAlt" />
 </section>
</template>

<script setup>
const props = defineProps({
  mainHeading: {
    type: String,
    default: 'Low Acid, Certified Organic Coffee with Delicious, Full Flavor',
  },
  subHeading: {
    type: String,
    default: 'Here\'s Just a Few of The Qualities of This Coffee',
  },
  contentHeading: {
    type: String,
    default: 'Swiss Water Decaffeinated',
  },
  contentText: {
    type: String,
    default: 'We use the <strong>chemical-free</strong> Swiss Water Process to decaffeinate these coffee beans. The combination of pure, clean water, temperature, and the right amount of time create what we call "flavor-charged water," a Green Coffee Extract (GCE). The result is premium decaf coffee that retains the maximum amount of flavor. Our Medium Roast Decaf Coffee is available in Whole Bean and Pre-Ground.',
  },
  diagramImageSrc: {
    type: String,
    default: '/assets/images/diagram.jpg',
  },
  diagramImageAlt: {
    type: String,
    default: 'Decaf Coffee Process Diagram',
  },
  diagramImageMobileSrc: {
    type: String,
    default: '/assets/images/diagram.jpg',
  },
  diagramImageMobileAlt: {
    type: String,
    default: 'Decaf Coffee Process Diagram Mobile',
  },
  decorImageSrc: {
    type: String,
    default: '/assets/images/decaf-diagram-bottom-new.png',
  },
  decorImageAlt: {
    type: String,
    default: 'Decaf Coffee',
  },
});

defineBuilderComponent({
  friendlyName: 'TextDescriptionFullImage',
  inputs: [
    {
      name: 'mainHeading',
      type: 'richText',
      friendlyName: 'Main Heading',
      defaultValue: 'Low Acid, Certified Organic Coffee with Delicious, Full Flavor',
    },
    {
      name: 'subHeading',
      type: 'richText',
      friendlyName: 'Sub Heading',
      defaultValue: 'Here\'s Just a Few of The Qualities of This Coffee',
    },
    {
      name: 'contentHeading',
      type: 'richText',
      friendlyName: 'Content Heading',
      defaultValue: 'Swiss Water Decaffeinated',
    },
    {
      name: 'contentText',
      type: 'richText',
      friendlyName: 'Content Text',
      defaultValue: 'We use the <strong>chemical-free</strong> Swiss Water Process to decaffeinate these coffee beans. The combination of pure, clean water, temperature, and the right amount of time create what we call "flavor-charged water," a Green Coffee Extract (GCE). The result is premium decaf coffee that retains the maximum amount of flavor. Our Medium Roast Decaf Coffee is available in Whole Bean and Pre-Ground.',
    },
    {
      name: 'diagramImageSrc',
      type: 'file',
      friendlyName: 'Diagram Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/diagram.jpg',
    },
    {
      name: 'diagramImageAlt',
      type: 'text',
      friendlyName: 'Diagram Image Alt Text',
      defaultValue: 'Decaf Coffee Process Diagram',
    },
    {
      name: 'diagramImageMobileSrc',
      type: 'file',
      friendlyName: 'Diagram Image Mobile',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/diagram.jpg',
    },
    {
      name: 'diagramImageMobileAlt',
      type: 'text',
      friendlyName: 'Diagram Image Mobile Alt Text',
      defaultValue: 'Decaf Coffee Process Diagram Mobile',
    },
    {
      name: 'decorImageSrc',
      type: 'file',
      friendlyName: 'Decorative Bottom Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/decaf-diagram-bottom-new.png',
    },
    {
      name: 'decorImageAlt',
      type: 'text',
      friendlyName: 'Decorative Image Alt Text',
      defaultValue: 'Decaf Coffee',
    },
  ],
});
</script>